import { createFeatureSelector, createSelector } from '@ngrx/store';

const getPortalState = createFeatureSelector('PORTAL_STORE');

export const getRollupGroupingSlice = createSelector(
  getPortalState,
  (state: any) => state.rollupGrouping,
);

export const getRollupGroupingLoadedStatus = createSelector(
  getRollupGroupingSlice,
  (state: any) => state.loaded,
);

export const getRollupGroupingData = createSelector(
  getRollupGroupingSlice,
  (state: any) => state.groupingData,
);
